import PlanReview from "./PlanReview";
import FamilyMembers from "./FamilyMembers";
import CardSelect from "./CardSelect";
import PayAndUpgrade from "./PayAndUpgrade";
import PayResultModal from "./PayResultModal";

const paymentComponents = {
  PlanReview,
  FamilyMembers,
  CardSelect,
  PayAndUpgrade,
  PayResultModal
}

export default paymentComponents;